/**
 * Portal User Domain
 * Generic authenticated user type for all portal roles (admin, moderator, student, guardian).
 * Replaces the old Moderator type from moderators-mock.ts as the primary auth type.
 */

export type PortalRole = 'student' | 'moderator' | 'admin' | 'guardian';

/** The roles that sign in with a password, on the staff portal's own screen (app.tsx's ?mod=). */
export type StaffRole = Extract<PortalRole, 'admin' | 'moderator'>;

export interface PortalUser {
  id: string;
  name: string;
  firstName?: string;
  lastName?: string;
  /** Absent for family-created students (they have no email) */
  email?: string;
  nakamaCustomId: string;
  /** Derived portal role — mapped from backend userType */
  role: PortalRole;
  /** Raw userType string from the backend (STUDENT, MODERATOR, PONDER_ADMIN, GUARDIAN) */
  userType: string;
  /** Whether the account email was verified (guardians created via signup are always true) */
  emailVerified?: boolean;
  /** Profile photo, shown in the header of every area; null = default icon. */
  avatarPhotoUrl?: string | null;
}

/** Maps a backend userType string to a PortalRole */
export function userTypeToRole(userType: string): PortalRole {
  switch (userType) {
    case 'PONDER_ADMIN':
      return 'admin';
    case 'MODERATOR':
      return 'moderator';
    case 'GUARDIAN':
      return 'guardian';
    case 'STUDENT':
    default:
      return 'student';
  }
}
